import { BaseElementToSimpleSapElementMapper } from '../baseElementToSimpleSapElementMapper';
import { ISimpleSapElement, SimpleSapElement } from '@/models/api/models/simpleSapElement';
import Element from '@/models/element';

export class VerticalWallToSimpleSapElementMapper extends BaseElementToSimpleSapElementMapper {

    public map(element: Element): ISimpleSapElement[] {
        const color = this.toColor(element);
        const type = this.formatType('PPN', element.shape.y, this.depth);
        const wall = SimpleSapElement.ELEMENT(type, color);
        return [wall];
    }
}
